import styled from 'styled-components/macro';
import { StyledModalContainer } from 'components/Modal/StyledComponents';
import { FocusableParent } from 'components/navigation';
import scaleSize from 'utils/scale-size';
import Button from 'components/Button';

export const StyledModal = styled(StyledModalContainer)`
  padding: ${scaleSize(100)}px;
  box-sizing: border-box;
`;

export const StyledModalContent = styled.div`
  & > td {
    vertical-align: top;
    text-align: center;
  }
`;

export const StyledModalNavigation = styled(FocusableParent)`
  height: 200px;

  & > td {
    text-align: center;
    vertical-align: middle;
  }
`;

export const StyledTitle = styled.div`
  font-size: ${scaleSize(48)}px;
  line-height: ${scaleSize(1.5, false)};
  letter-spacing: -0.33px;
  letter-spacing: normal;
  color: ${({ theme }) => theme.defaultColor};
  margin-bottom: ${scaleSize(50)}px;
`;

export const StyledDescription = styled.div`
  font-size: ${scaleSize(34)}px;
  line-height: ${scaleSize(1.5, false)};
  letter-spacing: normal;
  color: ${({ theme }) => theme.mainTextColor};
`;

export const StyledButton = styled(Button)`
  margin: 10px 0;
`;
